import React from 'react';
import {browserHistory, Route, Router} from 'react-router';
import store from 'store';

import ReactGA from 'react-ga';

import App from './components/App';
import DashboardContainer from './containers/dashboards/DashboardContainer';
import Error404 from './containers/errors/Error404';
import LoginForm from './containers/authentication/LoginForm';
import RegisterForm from './containers/authentication/RegisterForm';
import TenantApplicationContainer from './containers/tenant/application/TenantApplicationContainer';
import SingleListing from './containers/listings/SingleListing';
import GuarantorContainer from "./containers/guarantor/GuarantorContainer";
import ReferenceContainer from "./containers/reference/ReferenceContainer";
import ReferenceConfirmed from "./containers/reference/ReferenceConfirmed";
import OwnerApplications from "./containers/owner/applications/OwnerApplications";
import SettingsContainer from "./containers/settings/SettingsContainer";
import TenantBillingContainer from "./containers/tenant/billing/TenantBillingContainer";
import ClaimPropertyContainer from "./containers/unclaimed/ClaimPropertyContainer";
import ConfirmEmailContainer from "./containers/confirm_email/ConfirmEmailContainer";
import ErrorBrokenLink from "./containers/errors/ErrorBrokenLink";
import ExploreContainer from "./containers/tenant/explore/ExploreContainer";
// import Sandbox from "./containers/dashboards/Sandbox";
// import TUCreditTester from "./components/application/credit/TUCreditTester";

// Initialize Google Analytics
ReactGA.initialize('UA-60172533-1');

function fireTracking() {
    ReactGA.set({page: window.location.pathname});
    ReactGA.pageview(window.location.pathname); // send page views to Google Analytics
}

function routeIfAuthenticated(nextState, replace) {
    // basic authentication to see if user has a token... if not, redirect them
    const authenticated = store.get('access_token') && store.get('type');
    if (authenticated) {
        replace({
            pathname: '/dashboard/',
            state: {nextPathname: nextState.location.pathname}
        });
    }
}

function requireAuth(nextState, replace) {
    // basic authentication to see if user has a token... if not, redirect them
    const authenticated = store.get('access_token') && store.get('type');
    if (!authenticated) {
        replace({
            pathname: '/login',
            state: {nextPathname: nextState.location.pathname}
        });
    }
}

function requireTenant(nextState, replace) {
    const authenticated = store.get('access_token') && store.get('type') === 'tenant';
    if (!authenticated) {
        replace({
            pathname: '/dashboard/',
            state: {nextPathname: nextState.location.pathname}
        });
    }
}

function requireOwner(nextState, replace) {
    const authenticated = store.get('access_token') && store.get('type') === 'landlord';
    if (!authenticated) {
        replace({
            pathname: '/dashboard/',
            state: {nextPathname: nextState.location.pathname}
        });
    }
}

const routes = (
    <Router onUpdate={fireTracking} history={browserHistory}>
        <Route path="/" component={App}>
            <Route path="login" component={LoginForm} onEnter={routeIfAuthenticated}/>
            <Route path="register" component={RegisterForm} onEnter={routeIfAuthenticated}/>
            <Route path="listings/:apply_key" component={SingleListing}/>
            <Route path="dashboard" component={DashboardContainer} onEnter={requireAuth}/>
            <Route path="explore" component={ExploreContainer} onEnter={requireTenant}/>
            <Route path="application" component={TenantApplicationContainer} onEnter={requireTenant}/>
            <Route path="applications" component={OwnerApplications} onEnter={requireOwner}/>
            <Route path="billing" component={TenantBillingContainer} onEnter={requireTenant}/>
            <Route path="settings" component={SettingsContainer} onEnter={requireAuth}/>
            <Route path="claim" component={ClaimPropertyContainer}/>
            <Route path="verify/email/:user_id/:token" component={ConfirmEmailContainer}/>
            <Route path="confirm/guarantor/:tenant_id/:key" component={GuarantorContainer}/>
            <Route path="confirm/reference/:rental_id/:key" component={ReferenceContainer}/>
            <Route path="confirm/reference/success" component={ReferenceConfirmed}/>
            {/*<Route path="sandbox" component={Sandbox}/>*/}
            {/*<Route path="/test" component={TUCreditTester}/>*/}
            <Route path="/invalid_link" component={ErrorBrokenLink}/>
            <Route path="*" component={Error404}/>
        </Route>
    </Router>
);

export default routes;


// WEBPACK FOOTER //
// ./src/routes.js